import { zodResolver } from "@hookform/resolvers/zod";

import { Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { type RoomFormDto, createRoomDtoSchema } from "slde-api/dto-schemas";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

interface RoomFormProps {
  defaultValues?: RoomFormDto;
  onSubmit: (values: RoomFormDto) => void;

  disabled?: boolean;
  loading?: boolean;
}
export function RoomForm({
  onSubmit: onSubmitProps,
  defaultValues,
  disabled,
  loading,
}: RoomFormProps) {
  const form = useForm<RoomFormDto>({
    resolver: zodResolver(createRoomDtoSchema),
    defaultValues,
  });

  function onSubmit(values: RoomFormDto) {
    onSubmitProps(values);
  }

  return (
    <div className="flex gap-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field: { value, ...field } }) => (
                <FormItem>
                  <FormLabel>Nazwa</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Sala A"
                      value={value ?? ""}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="description"
              render={({ field: { value, ...field } }) => (
                <FormItem>
                  <FormLabel>Opis</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Średnia sala, pomieści 200 osób"
                      value={value ?? ""}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <Button type="submit" disabled={disabled || loading}>
            {!!defaultValues ? "Edytuj" : "Dodaj"}
            {loading && <Loader2 className="animate-spin" />}
          </Button>
        </form>
      </Form>
    </div>
  );
}
